import React from 'react';
import { APITypes } from '../../../primary-record-types';
import { useMedicalProfileFileImage } from '../../../hooks/api/useMedicalProfileFileImage';
import { View } from 'react-native';
import { Loader } from '../../v2BaseComponents/Loader';
import Icon from '../../v2BaseComponents/Icon';
import Skeleton from '../../v2BaseComponents/Skeleton';
import PageDisplay from '../FileDisplay/PageDisplay';

export type MedicalProfileFileIconDisplayOwnProps = {
    file: APITypes.medicalProfileFilesService.MedicalProfileFileListItem;
    width: number;
    height: number;
};

export type MedicalProfileFileIconDisplayProps = MedicalProfileFileIconDisplayOwnProps;

const MedicalProfileFileIconDisplay: React.FC<MedicalProfileFileIconDisplayProps> = ({ file, width, height }) => {
    const medicalProfileFileImage = useMedicalProfileFileImage({
        medicalProfileId: file.medicalProfileId,
        medicalProfileFileId: file.medicalProfileFileId,
        page: 1,
    });

    const renderInContainer = (children: React.ReactNode) => (
        <View
            style={{
                width,
                height,
                justifyContent: 'center',
                alignItems: 'center',
            }}
            testID="medical-profile-file-icon-display-container"
        >
            {children}
        </View>
    );

    if (file.processingStatus === 'processing') {
        return renderInContainer(<Loader size="sm" />);
    } else if (file.processingType === 'audio') {
        return renderInContainer(<Icon name="Volume2" size="card-list-icon" />);
    } else if (medicalProfileFileImage.status === 'loading') {
        return (
            <Skeleton
                style={{
                    width,
                    height,
                }}
            />
        );
    } else if (medicalProfileFileImage.status === 'loaded') {
        return (
            <PageDisplay
                fileUrl={medicalProfileFileImage.image.downloadUrl}
                containerDimensions={{ width, height }}
                pageDimensions={medicalProfileFileImage.image.dimensions}
                type={medicalProfileFileImage.image.type}
                rotation={medicalProfileFileImage.image.rotation}
            />
        );
    } else {
        return renderInContainer(<Icon name="FileText" size="card-list-icon" />);
    }
};

export default React.memo(MedicalProfileFileIconDisplay);
